export default __webpack_public_path__ + "static/media/01.00d24b79.gif";